import { apiClient } from '@/lib/apiClient';
import type {
  Usuario, PerfilCadastro,
  CriarUsuarioRequest, AtualizarUsuarioRequest, ResetSenhaRequest,
  SalvarPerfilRequest,
} from '../types';
import type { DirecaoOrdenacao, PaginadoResponse } from '@/lib/consultas';

export interface FiltrosUsuarios {
  busca?: string;
  perfilId?: number | null;
  empresaId?: number | null;
  ativo?: boolean | null;
  ordenarPor: 'nome' | 'login' | 'email' | 'ultimoAcesso';
  direcao: DirecaoOrdenacao;
  pagina: number;
  tamanhoPagina: number;
}

// ── Usuários ──────────────────────────────────────────────────────────────

const USERS = '/api/cadastros/usuarios';

export const usuariosService = {
  listar: (busca?: string) =>
    apiClient.get<{ itens: Usuario[]; total: number }>(USERS, {
      params: { busca, tamanhoPagina: 200 },
    }).then(r => r.data),

  /** Consulta paginada no servidor (tela Usuários). */
  pesquisar: (f: FiltrosUsuarios) =>
    apiClient.get<PaginadoResponse<Usuario>>(USERS, {
      params: {
        busca:         f.busca?.trim() || undefined,
        perfilId:      f.perfilId ?? undefined,
        empresaId:     f.empresaId ?? undefined,
        ativo:         f.ativo ?? undefined,
        ordenarPor:    f.ordenarPor,
        direcao:       f.direcao,
        pagina:        f.pagina,
        tamanhoPagina: f.tamanhoPagina,
      },
    }).then(r => r.data),

  getById: (id: number) =>
    apiClient.get<Usuario>(`${USERS}/${id}`).then(r => r.data),

  criar: (req: CriarUsuarioRequest) =>
    apiClient.post<Usuario>(USERS, req).then(r => r.data),

  atualizar: (id: number, req: AtualizarUsuarioRequest) =>
    apiClient.put(`${USERS}/${id}`, req).then(r => r.data),

  resetSenha: (id: number, req: ResetSenhaRequest) =>
    apiClient.post(`${USERS}/${id}/reset-senha`, req).then(r => r.data),

  inativar: (id: number) =>
    apiClient.delete(`${USERS}/${id}`).then(r => r.data),
};

// ── Perfis (CRUD) ─────────────────────────────────────────────────────────

const PERFIS = '/api/cadastros/perfis';

export const perfisCadastroService = {
  listar: () =>
    apiClient.get<PerfilCadastro[]>(PERFIS).then(r => r.data),

  criar: (req: SalvarPerfilRequest) =>
    apiClient.post<PerfilCadastro>(PERFIS, req).then(r => r.data),

  atualizar: (id: number, req: SalvarPerfilRequest) =>
    apiClient.put(`${PERFIS}/${id}`, req).then(r => r.data),

  excluir: (id: number) =>
    apiClient.delete(`${PERFIS}/${id}`).then(r => r.data),
};
